import { render, staticRenderFns } from "./CadastroFormasDePagamento.vue?vue&type=template&id=81158854&"
import script from "./CadastroFormasDePagamento.vue?vue&type=script&lang=js&"
export * from "./CadastroFormasDePagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports